export default __webpack_public_path__ + "static/media/ETHX.8546e3e3.svg";